import { Badge } from "@/components/ui/badge";

const MAP = {
  Active: "bg-emerald-50 dark:bg-emerald-950/50 text-emerald-700 dark:text-emerald-300 border-emerald-200 dark:border-emerald-900",
  Completed: "bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 border-slate-200 dark:border-slate-800",
  Pending: "bg-amber-50 dark:bg-amber-950/50 text-amber-700 dark:text-amber-300 border-amber-200 dark:border-amber-900",
  "In Progress": "bg-primary/10 dark:bg-primary/15 text-primary border-primary/30",
  "Pending Payment": "bg-amber-50 dark:bg-amber-950/50 text-amber-700 dark:text-amber-300 border-amber-200 dark:border-amber-900",
  Upcoming: "bg-slate-50 dark:bg-slate-900 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-800",
  High: "bg-red-50 dark:bg-red-950/50 text-red-700 dark:text-red-300 border-red-200 dark:border-red-900",
  Medium: "bg-amber-50 dark:bg-amber-950/50 text-amber-700 dark:text-amber-300 border-amber-200 dark:border-amber-900",
  Low: "bg-slate-50 dark:bg-slate-900 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-800",
};

export default function StatusBadge({ status, className = "", testid }) {
  const cls = MAP[status] || "bg-slate-50 dark:bg-slate-900 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-800";
  return (
    <Badge
      variant="outline"
      data-testid={testid}
      className={`border ${cls} rounded-full px-2.5 py-0.5 text-[11px] font-medium tracking-wide ${className}`}
    >
      {status}
    </Badge>
  );
}
